import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: route => ({
      shot: (String(route.query.shot).toLowerCase() === 'true'),
      avocado: (String(route.query.avocado).toLowerCase() === 'true'),
      no: route.query.no === undefined ? '' : route.query.no,
      hmcNo: route.query.hmcNo === undefined ? '' : route.query.hmcNo,
      lk: (String(route.query.lk).toLowerCase() === 'true'),
      ch: route.query.ch === undefined ? 'web' : route.query.ch,
    })
  },
  {
    path: '/:vno',
    name: 'Home2',
    component: Home,
    props: route => ({
      shot: false,
      avocado: false,
      no: '',
      hmcNo: '',
      vno: route.params.vno,
      lk: true,
      ch: 'web',
    })
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
